import Icon from '@/components/icons/Icon';
import { _t } from '@/locale';
import { PlaceWithAssociation } from './AssociationDrawer.types';

export const Card = ({ imageUrl, name, summary }: PlaceWithAssociation['associations'][number]) => {
  return (
    <div className="pt-sm pb-md px-sm bg-bg_neutral border-border_regular space-y-sm flex flex-col rounded-sm border">
      <div className="gap-2xs flex items-center ">
        <Icon variant="industry-organization" color="fg_secondary" />
        <span className="text-fg_secondary flex-1">{_t('member')}</span>
        <img src={imageUrl} className="h-[28px] w-auto flex-shrink-0" height={28} alt={name} />
      </div>
      <div className="flex items-center">
        <div className="gap-2xs flex flex-col">
          <h2 className="text-fg_primary text-m">{name}</h2>
          <p className="text-fg_secondary text-s line-clamp-2">{summary}</p>
        </div>
        <Icon variant="chevron-right" size="xs" color="fg_secondary" />
      </div>
    </div>
  );
};
